let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dk1NB")).then(() => parcelRequire('cGdIS'));